/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const LIGHT_THEME_EFFECTS = {
  'effect-drop-none': '0px 0px 0px 0px hsl(0 0% 100% / 0%)',
  'effect-drop-small': '0px 1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-drop-medium': '0px 5px 8px -3px hsl(240 40% 16% / 16%)',
  'effect-drop-large': '0px 13px 21px -8px hsl(240 40% 16% / 24%)',
  'effect-inner-small-top': '0px 1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-right': '-1px 0px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-bottom': '0px -1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-left': '1px 0px 3px 0px hsl(240 40% 16% / 8%)'
}
export const DARK_THEME_EFFECTS = {
  'effect-drop-none': '0px 0px 0px 0px hsl(0 0% 100% / 0%)',
  'effect-drop-small': '0px 1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-drop-medium': '0px 5px 8px -3px hsl(240 40% 16% / 16%)',
  'effect-drop-large': '0px 13px 21px -8px hsl(240 40% 16% / 24%)',
  'effect-inner-small-top': '0px 1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-right': '-1px 0px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-bottom': '0px -1px 3px 0px hsl(240 40% 16% / 8%)',
  'effect-inner-small-left': '1px 0px 3px 0px hsl(240 40% 16% / 8%)'
}
